import { cn } from '@/lib/utils'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info'
  size?: 'sm' | 'md'
  className?: string
}

export function Badge({ children, variant = 'default', size = 'md', className }: BadgeProps) {
  const variantStyles = {
    default: 'bg-[var(--pd-muted)] text-[var(--pd-foreground)] border-[var(--pd-border)]',
    success: 'bg-[var(--pd-success)]/10 text-[var(--pd-success)] border-[var(--pd-success)]/20',
    warning: 'bg-[var(--pd-warning)]/10 text-[var(--pd-warning)] border-[var(--pd-warning)]/20',
    danger: 'bg-[var(--pd-danger)]/10 text-[var(--pd-danger)] border-[var(--pd-danger)]/20',
    info: 'bg-[var(--pd-info)]/10 text-[var(--pd-info)] border-[var(--pd-info)]/20'
  }
  
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  }

  return (
    <span className={cn(
      'inline-flex items-center font-medium rounded-lg border',
      variantStyles[variant],
      sizeStyles[size],
      className
    )}>
      {children}
    </span>
  )
}
